/**
 * Megamenu & Catalog Hover Interaction
 * Handles smooth opening/closing of header dropdowns on hover.
 */
function initMegaMenuHover() {
  const menuItems = document.querySelectorAll(".header__inline-menu > ul > li");
  let activeMenuItem = null;

  menuItems.forEach((item) => {
    if (item.dataset.megamenuHoverBound) return;
    item.dataset.megamenuHoverBound = "true";

    const detailsElement = item.querySelector("details");

    item.addEventListener("mouseenter", () => {
      // Close all other open details immediately when entering any item
      menuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          const otherDetails = otherItem.querySelector("details");
          if (otherDetails && otherDetails.hasAttribute("open")) {
            otherDetails.removeAttribute("open");
          }
        }
      });

      if (detailsElement) {
        detailsElement.setAttribute("open", "true");
        activeMenuItem = item;
      } else {
        activeMenuItem = null;
      }
    });

    if (detailsElement) {
      item.addEventListener("mouseleave", () => {
        setTimeout(() => {
          if (!item.matches(":hover")) {
            detailsElement.removeAttribute("open");
            if (activeMenuItem === item) activeMenuItem = null;
          }
        }, 250);
      });
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMegaMenuHover);
} else {
  initMegaMenuHover();
}

document.addEventListener("shopify:section:load", initMegaMenuHover);
